export default function startCase({ value }) {
  if (typeof value !== "string") {
    /* eslint-disable */
    return console.error("The 'value' parameter is not a string.")
    /* eslint-enable */
  }

  let str = value.replace(/^[^a-zA-Z0-9]*|[^a-zA-Z]*$/g, "")
  str = str.replace(/[^a-zA-Z0-9]|([A-Z]+)/g, " $1").trim()
  return str.split(" ")
    .filter((el) => el !== "")
    .map((el) => el.slice(0, 1).trim().toUpperCase() + el.slice(1)).join(" ")
}
